import { Component, OnDestroy } from "@angular/core";
import { Subject, debounceTime, distinctUntilChanged, takeUntil } from "rxjs";
import { RouterService } from "src/app/libs/data-access/services/router/router.service";
import { FlightsFacade } from "src/app/pages/flights-page/src/app/data-access/services/flights.facade";
import { FormControl, Validators, FormGroup, FormBuilder, FormArray, AbstractControl } from "@angular/forms";
import { parseLocation } from "src/app/pages/flights-page/src/app/ui/utils/flights-page.utils";
import { HotelsFacade } from "src/app/pages/hotels/data-access/services/hotels.facade";
import { PagesRoute } from "src/app/pages/src/app/ui/routes/routes.enum";
import { EventsFacade } from "src/app/pages/events/src/app/data-access/services/events.facade";
import { CheckoutFacade } from "src/app/libs/data-access/services/checkout/services/checkout.facade";
import { IOrderInfo } from "../data-access/model/interfaces/order-requests.interface";
import { CreateOrderPassenger, ICreateFlightOrder, IdentityDocument } from "src/app/pages/flights-page/src/app/data-access/model/interfaces/flight-create-request.interface";
import { HotelBookingInterface, PaxesBookingInterface } from "src/app/pages/hotels/data-access/model/interfaces/hotel-booking.interface";
import { IOrderTicketsDetails } from "src/app/pages/events/src/app/data-access/model/interfaces/event-order-interface";
import { isAdultBirthDate, isChildBirthDate, isMobilePhoneValidator, isEmailValidator } from "src/app/libs/ui/utils/input-validators.utils";
import { Countries } from "src/app/libs/data-access/models/consts/country.const";
import { OrderStatusEnum } from "../data-access/model/enums/order-status.enum";
import { DatePipe } from "@angular/common";
import { environment } from '../../../../../core/environments/environment';
import { DashboardFacade } from "src/app/pages/admin-dashboard/data-access/services/dashboard.facade";
import { CurrencyFacade } from "src/app/libs/data-access/services/currency/services/currency.facade";
import { LocalStorageUtil } from "src/app/libs/ui/utils/local-storage.utils";
import { CURRENCY_RATES_LOCAL_STORAGE_KEY, CURRENT_CURRENCY_TYPE_LOCAL_STORAGE_KEY } from "src/app/libs/data-access/services/currency/consts/currency.consts";
import { ResetState } from "src/app/actions/global.actions";
import { Store } from "@ngrx/store";
import { SharedService } from "src/app/libs/common/services/shared.service";
import { isEqual } from "lodash";
import { CountryCode, parsePhoneNumberFromString } from 'libphonenumber-js';
import { CurrencyConverterPipe } from "src/app/libs/common/pipes/currency-converter/currency-converter.pipe";

declare const intlTelInput: any;
@Component({
  selector: "tic-trip-checkout",
  templateUrl: "./trip-checkout.component.html",
  styleUrls: ["./trip-checkout.component.scss"],
})
export class TripCheckoutComponent implements OnDestroy {
  private destroy$ = new Subject<void>();
  private kill$ = new Subject<void>();

  loadedEvent: any;
  loadedEventFlag: boolean = false;
  loadedFlight: any = {};
  loadedFlightFlag: boolean = false;
  loadedHotel: any = {};
  loadedHotelFlag: boolean = false;
  loadedOrderInfo: any = {};
  loadedOrderInfoFlag: boolean = false;
  data: any = {};
  totalMembers: number = 0;
  typopup = false;
  totalCost: number = 0;
  totalActualCost: number = 0;
  orderId: any;
  countryCode: string = '1';
  countryName: CountryCode = 'US';
  eventBookingCount: number = 0;
  isLoading: boolean = false;
  countries: any = Countries;
  readonly parseLocation = parseLocation;
  packageTypeId: number;
  eventTotal = 0;
  totalPackagePrice!: number;
  flightPrice = 0;
  hotelPrice = 0;
  eventPrice = 0;
  discount=0;
  hotelBooking: any = {};
  flightBooking: any = {};
  flightResp: any = {};
  eventBooking: any[] = [];
  eventCallFlag: boolean = false;
  flightCallFlag: boolean = false;
  hotelCallFlag: boolean = false;
  conditionExecuted: boolean = false;
  CouponCallFlag?: boolean=null;
  isApplying:boolean=false;
  couponInput: boolean=true;
  couponDetail:any;
  checkoutFormGroup!: FormGroup;
  paxDetail: any = {};
  paxFormGroups: FormGroup[] = [];
  firstNameContactControl = new FormControl("", [Validators.required]);
  lastNameContactControl = new FormControl("", [Validators.required]);
  mobileNoContactControl = new FormControl("", [
    Validators.required,
    this.phoneNumberValidator.bind(this)
  ]);
  emailContactControl = new FormControl("", [
    Validators.required,
    isEmailValidator(),
  ]);
  couponControl = new FormControl("",[Validators.nullValidator]);
  isCouponValid: boolean = false;
  iti: any;
  
  constructor(
    public eventFacade: EventsFacade,
    public flightFacade: FlightsFacade,
    public hotelFacade: HotelsFacade,
    public routerService: RouterService,
    private facadeCheckout: CheckoutFacade,
    private formBuilder: FormBuilder,
    private datePipe: DatePipe,
    public dashboardFacade: DashboardFacade,
    public currencyFacade:CurrencyFacade,
    public globalStore:Store,
    public sharedService:SharedService,
    public currencyConverter123:CurrencyConverterPipe
  ) {}

  ngOnInit(): void {
    this.initializeRouteParamsSubscription();
    this.initializeFormControls();
    this.subscribeToFacadeCheckoutData();
    this.flightHotelBooking();
  }

  ngAfterViewInit() {
    const phoneInput = document.querySelector("#mobile-no");
    this.iti = intlTelInput(phoneInput, {
      utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.12/js/utils.min.js"
    });
    this.iti.promise.then(() => {
      const countryCode = this.iti.getSelectedCountryData().iso2;
      this.iti.setCountry(countryCode);
    });

    phoneInput.addEventListener("countrychange", () => {
      const countryData = this.iti.getSelectedCountryData();
      this.countryCode = countryData.dialCode;
      this.countryName = countryData.iso2.toUpperCase();
      this.validatePhoneNumber();
    });

    phoneInput.addEventListener("keyup", () => {
      this.validatePhoneNumber();
    });
  }

  phoneNumberValidator(control: FormControl) {
    if (!this.iti || (!control.dirty && !control.touched)) {
      return null; // Skip validation on page load
    }
    const isValid = this.iti.isValidNumber();
    return isValid ? null : { invalidPhone: true }; // Return error object if invalid
  }

  toE164Format(phone: string, countryCode: CountryCode): string | null {
    const phoneNumber = parsePhoneNumberFromString(phone, countryCode);
    return phoneNumber ? phoneNumber.format('E.164') : null;
  }

  validatePhoneNumber() {
    const phoneInput = document.querySelector("#mobile-no") as HTMLInputElement;
    if (this.iti && phoneInput) {
      const isValid = this.iti.isValidNumber();
      if (!isValid) {
        this.mobileNoContactControl.setErrors({ invalidPhone: true });
      } else {
        this.mobileNoContactControl.setErrors(null);
      }
    }
    this.mobileNoContactControl.updateValueAndValidity();
  }

  private initializeRouteParamsSubscription(): void {
    this.routerService
      .getUrlParams()
      .pipe(takeUntil(this.destroy$))
      .subscribe((res) => {
        this.handleUrlParams(res);
      });
  }

  private handleUrlParams(res: any): void {
    this.data = res;
    if (this.data.packageType) {
      this.packageTypeId = this.data.packageType;
    }
  }

  private initializeFormControls(): void {
    this.totalMembers =
      parseInt(this.data.numberOfAdults) + parseInt(this.data.numberOfChildren);
    for (let i = 0; i < this.totalMembers; i++) {
      let memberType =
        i < parseInt(this.data.numberOfAdults) ? "adult" : "child";
      this.paxFormGroups.push(this.createPaxFormGroup(memberType));
    }
    this.checkoutFormGroup = new FormGroup({
      firstNameContactControl: this.firstNameContactControl,
      lastNameContactControl: this.lastNameContactControl,
      mobileNoContactControl: this.mobileNoContactControl,
      emailContactControl: this.emailContactControl,
      couponControl:this.couponControl,
      paxFormData: this.formBuilder.array(this.paxFormGroups),
    });
    if (this.data.packageType) {
      this.checkoutFormGroup.valueChanges
        .pipe(debounceTime(1000))
        .subscribe((value) => {
          this.facadeCheckout.setPassangerDetail(value);
            sessionStorage.setItem("paxdetail", JSON.stringify(value));
        });
    }
  }

  private subscribeToFacadeCheckoutData(): void {
    this.facadeCheckout.vm$.pipe(
        distinctUntilChanged((prev, curr) => JSON.stringify(prev) === JSON.stringify(curr)),
        takeUntil(this.destroy$)
      ).subscribe((data) => {
      this.handleFacadeCheckoutData(data);
    });
    this.facadeCheckout.saveFlightOrderInfo$.pipe(
      distinctUntilChanged((prev, curr) => JSON.stringify(prev) === JSON.stringify(curr)),
      takeUntil(this.destroy$)
    ).subscribe((data) => {
      if (
        data &&
        data &&
        this.isObjectNotEmpty(data) &&
        !this.flightCallFlag
      ) {
        this.flightResp = data;
        if(data.error){
          this.sharedService.Error(data?.flightOrder.errors[0].message);
          this.isLoading = false;
          this.unsubscribeSaveMultipleEventOrderInfo();
        } else{
          this.flightBooking = data;
          this.flightCallFlag = true;
          if (this.packageTypeId == 2) {
            this.createOrderInfo();
          }
          if (this.packageTypeId == 1) {
            this.createHotelBooking();
          }
        }
      }
    });
    this.facadeCheckout.saveHotelOrderInfo$.pipe(
      distinctUntilChanged((prev, curr) => JSON.stringify(prev) === JSON.stringify(curr)),
      takeUntil(this.destroy$)
    ).subscribe((data) => {
      if (
        data &&
        this.isObjectNotEmpty(data) &&
        !this.hotelCallFlag
      ) {
        this.hotelBooking = data;
        this.hotelCallFlag = true;
        if (this.packageTypeId == 1 || this.packageTypeId == 3) {
          this.createOrderInfo();
        }
      } else{
        if(data === null){
          this.sharedService.Error('Hotel Order Faild!');
          this.isLoading = false;
          this.unsubscribeSaveMultipleEventOrderInfo();
        }
      }
    });
  }

  flightHotelBooking() {
    this.facadeCheckout.saveMultipleEventOrderInfo$.pipe(
      takeUntil(this.kill$)
    ).subscribe((data) => {
      if (data && this.isObjectNotEmpty(data) ) {
        if(data[0].orderConfirmation.code){
          this.sharedService.Error('Event '+ data[0].orderConfirmation.message);
          this.isLoading = false;
          this.unsubscribeSaveMultipleEventOrderInfo();
        } else {
          this.eventBooking = data;
          if ((this.packageTypeId == 1 || this.packageTypeId == 2) && (this.flightResp.error || !this.eventCallFlag)) {
            this.eventCallFlag = true;
            this.createFlightBooking();
          }
          if (this.packageTypeId == 3) {
            this.eventCallFlag = true;
            this.createHotelBooking();
          }
        }
      }
    });
  }

  private unsubscribeSaveMultipleEventOrderInfo(): void {
    this.kill$.next();
    this.kill$.complete();
  }

  private async handleFacadeCheckoutData(data: any): Promise<void> {
    try{
      if (data && data.events && data.events.length > 0) {
        this.loadedEvent = data.events;
        this.loadedEventFlag = true;
        this.eventTotal = this.loadedEvent[0].totalPackagePrice;
      }
      if (data && data.flight) {
        this.loadedFlight = data.flight;
        if (this.isObjectNotEmpty(this.loadedFlight)) {
          this.loadedFlightFlag = true;
        }
      }
      if (data && data.hotel) {
        this.loadedHotel = data.hotel;
        if (this.isObjectNotEmpty(this.loadedHotel)) {
          this.loadedHotelFlag = true;
        }
      }
      if (data && data.totalPrice) {
        this.totalCost = data.totalPrice;
        this.totalActualCost=data.totalPrice;
      }
      if (data && data.packagePrice) {
        this.totalPackagePrice = data.packagePrice;
      }
      if (data && data.eventPrice) {
        this.eventPrice = data.eventPrice;
      }
      if (data && data.flightPrice) {
        this.flightPrice = data.flightPrice;
      }
      if (data && data.hotelPrice) {
        this.hotelPrice = data.hotelPrice;
      }
      if (data && data.passangerDetail) {
        this.paxDetail = data.passangerDetail;
        if (this.isObjectNotEmpty(this.paxDetail)) {
          this.populateForm(this.paxDetail);
        } else {
          const paxString = sessionStorage.getItem("paxdetail");
          if (paxString) {
            const pax=JSON.parse(paxString);
            if(pax && pax.couponControl!='' && this.CouponCallFlag==null){
              this.CouponCallFlag=false;
            }
            this.populateForm(JSON.parse(paxString));
          }
        }
      }
      if (data && 
        data.totalPrice>0 &&
        data.couponDetail &&
        this.isObjectNotEmpty(data.couponDetail) &&
        !this.CouponCallFlag) {
        this.couponDetail = data.couponDetail;
        if ( data.couponDetail.error == true ) {
          this.isCouponValid = false;
        } else {
          const startDate = new Date(data.couponDetail.coupon.fromDate);
          const endDate = new Date(data.couponDetail.coupon.toDate);
          const currentDate = new Date();
          if(data.couponDetail.coupon.isActive ==true && data.couponDetail.coupon.usage > 0 && currentDate >= startDate && currentDate <= endDate){
            this.isCouponValid = true;
            let convertedPrice = '0';
            const currentCurrencyType=LocalStorageUtil.getOption(CURRENT_CURRENCY_TYPE_LOCAL_STORAGE_KEY);
            const exchangeRates = LocalStorageUtil.getOption(CURRENCY_RATES_LOCAL_STORAGE_KEY)?.exchangeRate;
            if (exchangeRates) {
              convertedPrice = this.convertCurrency(
                parseInt(data.couponDetail.coupon.value),
                data.couponDetail.coupon.currency,
                currentCurrencyType ? currentCurrencyType : "USD",
                exchangeRates
              );
            }
            if(data.couponDetail.coupon) {
              if (data.couponDetail.coupon.discountType === "percentage") {
                this.discount = data.totalPrice * (parseInt(convertedPrice) / 100);
              } else {
                this.discount = parseInt(convertedPrice);
              }
            }
          }
          else{
            this.isCouponValid=false;
          }
        }
        this.CouponCallFlag=true;
        this.isApplying=false;
      }
      if (data && data.orderInfo) {
        if (this.isObjectNotEmpty(data.orderInfo)) {
          this.loadedOrderInfoFlag = true;
          this.loadedOrderInfo = data.orderInfo;
          this.totalCost = data.orderInfo.ourPrice;
          this.totalMembers = data.orderInfo.passengers.length;
        }
      }
      if (
        data &&
        data.saveOrderInfo &&
        this.isObjectNotEmpty(data.saveOrderInfo)
      ) {
        this.isLoading = false;
        if (data.saveOrderInfo.message === "saved") {
          if (!this.conditionExecuted) {
            this.conditionExecuted = true;
            const emailBody = {
              subject: `Order Completed`,
              html:
                `<div style="font-family: Arial, sans-serif; margin: 0; padding: 0; background-color: #f4f4f4;">` +
                `<div style="width: 100%; max-width: 600px; margin: 0 auto; background-color: #ffffff; padding: 20px; box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);">` +
                `<div style="text-align: center; padding: 20px 0;">` +
                `<img src="https://trripi-stg.com/assets/images/logo.png" alt="Company Logo" style="max-width: 100px;">` +
                `<h1 style="margin: 0;">Thank You for Your Order!</h1></div>` +
                `<div style="padding: 20px;">` +
                `<p>Hi ${this.firstNameContactControl.value} ${this.lastNameContactControl.value},</p>` +
                `<p>Thank you for your order. We are excited to get started on it right away. Below are the details of your order:</p>` +
                `<div style="margin: 20px 0;">` +
                `<table width="100%" style="border-collapse: collapse;">` +
                `<tr>` +
                `<th style="text-align: left; padding: 8px; border-bottom: 1px solid #dddddd;">Order Number:</th>` +
                `<td style="padding: 8px; border-bottom: 1px solid #dddddd;">${this.orderId}</td>` +
                `</tr>` +
                `<tr>` +
                `<th style="text-align: left; padding: 8px; border-bottom: 1px solid #dddddd;">Order Date:</th>` +
                `<td style="padding: 8px; border-bottom: 1px solid #dddddd;">${this.datePipe.transform(new Date(), "dd MMMM yyyy")}</td>` +
                `</tr>` +
                (this.discount ? 
                  `<tr>` +
                  `<th style="text-align: left; padding: 8px; border-bottom: 1px solid #dddddd;">Orignal Price:</th>` +
                  `<td style="padding: 8px; border-bottom: 1px solid #dddddd;"><del>${this.currencyConverter123.transform(this.totalCost)}</del></td>` +
                  `</tr>` +
                  `<tr>` +
                  `<th style="text-align: left; padding: 8px; border-bottom: 1px solid #dddddd;">Discount:</th>` +
                  `<td style="padding: 8px; border-bottom: 1px solid #dddddd;">${this.currencyConverter123.transform(this.discount)}</td>` +
                  `</tr>` 
                  : ``) +
                `<tr>` +
                `<th style="text-align: left; padding: 8px; border-bottom: 1px solid #dddddd;">Total:</th>` +
                `<td style="padding: 8px; border-bottom: 1px solid #dddddd;">${this.currencyConverter123.transform(Math.max(this.totalCost - (this.discount || 0), 0))}</td>` +
                `</tr>` +
                `</table>` +
                `</div>` +
                `<p>If you have any questions, feel free to contact our support team.</p>` +
                `<p>Best regards,<br>Trripi</p>` +
                `</div>` +
                `<div style="text-align: center; padding: 20px; font-size: 12px; color: #777777;">` +
                `<p>&copy; 2025 Trripi. All rights reserved.</p>` +
                `</div>` +
                `</div>` +
                `</div>`,
              emails: [this.emailContactControl.value],
            };
            
            this.dashboardFacade.sendEmail(emailBody);
            this.opentypopup();
            this.updateCouponCount();
            sessionStorage.removeItem("paxdetail");
          }
        }
      }
    } catch (error) {
      console.error('Error occurred:', error);
      this.isLoading = false;
    }
  }

  private createPaxFormGroup(type: string): FormGroup {
    return this.formBuilder.group({
      type: [{ value: type, disabled: true }, [Validators.required]],
      firstAndMiddleName: ["", [Validators.required]],
      lastName: ["", [Validators.required]],
      dob: [
        "",
        [
          Validators.required,
          type === "adult" ? isAdultBirthDate() : isChildBirthDate(),
        ],
      ],
      nationality: ["", [Validators.required]],
      passportNumber: ["", [Validators.required, Validators.minLength(4)]],
      city: ["", [Validators.required]]
    });
  }

  private populateForm(data: any): void {
    this.checkoutFormGroup.patchValue(data);
    if(this.couponControl.value!='' && this.CouponCallFlag===false){
      this.onHandleCoupon();
    }
    if (!this.data.packageType) {
      this.disableControls();
    }
  }

  private disableControls(): void {
    // Populate contact information
    this.checkoutFormGroup.controls["firstNameContactControl"].disable();
    this.checkoutFormGroup.controls["lastNameContactControl"].disable();
    this.checkoutFormGroup.controls["mobileNoContactControl"].disable();
    this.checkoutFormGroup.controls["emailContactControl"].disable();
    this.checkoutFormGroup.controls["couponControl"].disable();

    // Populate passenger details
    const paxFormArray = this.checkoutFormGroup.controls[
      "paxFormData"
    ] as FormArray;
    for (let i = 0; i < paxFormArray.length; i++) {
      const paxFormGroup = paxFormArray.at(i) as FormGroup;
      paxFormGroup.controls["type"].disable();
      paxFormGroup.controls["firstAndMiddleName"].disable();
      paxFormGroup.controls["lastName"].disable();
      paxFormGroup.controls["dob"].disable();
      paxFormGroup.controls["nationality"].disable();
      paxFormGroup.controls["passportNumber"].disable();
    }
  }

  isObjectNotEmpty(obj: any): boolean {
    return obj && Object.keys(obj).length > 0;
  }

  checkError(type: any, message: string) {
    let value = type.hasError("required") ? message : "";
    return value;
  }

  checkValidEmailError(type: any) {
    if (type.value !== "") {
      let value = type.hasError("invalidEmail") ? 'checkoutPage.formFields.email.errorMessage' : "";
      return value;
    }
    return "";
  }

  checkTypeError(type: any) {
    return type.hasError("required") ? "You must select passenger type" : "";
  }

  checkNameError(type: any) {
    return type.hasError("required")
      ? 'checkoutPage.formFields.lastName.requiredMessage'
      : "";
  }

  checkLastNameError(type: any) {
    return type.hasError("required") ? 'checkoutPage.formFields.lastName.errorMessage' : "";
  }

  checkDobError(type: any) {
    return type.hasError("required")
      ? 'checkoutPage.formFields.birthDate.requiredMessage'
      : "";
  }

  checkDobInvalidError(type: any) {
    return type.hasError("invalidBirthDate") || type.hasError("notChild")? 'checkoutPage.formFields.birthDate.errorMessage' : "";
  }

  checkDobNotAdultError(type: any) {
    return type.hasError("notAdult") ? 'checkoutPage.formFields.adult.errorMessage' : "";
  }

  checkMobileValidError(type: any) {
    // if (type.value !== "") {
    //   return type.hasError("invalidPhoneNumber")
    //     ? 'checkoutPage.formFields.phoneNumber.errorMessage'
    //     : "";
    // }
    if (type.hasError("invalidPhone")) {
      return type.hasError("invalidPhoneNumber")
        ? 'checkoutPage.formFields.phoneNumber.errorMessage'
        : "";
    }
    return "";
  }

  checkNationalityError(type: any) {
    return type.hasError("required") ? 'checkoutPage.formFields.nationality.requiredMessage' : "";
  }

  checkPassportError(control: AbstractControl | null): string {
    if (!control) {
      return '';
    }
  
    if (control.hasError('required')) {
      return 'checkoutPage.formFields.passportNumber.requiredMessage';
    }
    if (control.hasError('minlength')) {
      return 'checkoutPage.formFields.passportNumber.errorMessage'; // Message for minimum length
    }
  
    return '';
  }  

  private opentypopup() {
    this.typopup = true;
    this.routerService.setCheckoutState(true);
  }

  closePopupty(): void {
    this.typopup = false;
    this.facadeCheckout.resetSaveOrderInfo();
    this.facadeCheckout.resetSaveEventOrderInfo();
    this.facadeCheckout.resetSaveHotelOrderInfo();
    this.facadeCheckout.resetSaveFlightOrderInfo();
    this.globalStore.dispatch(ResetState());
    this.routerService.navigate(PagesRoute.HomePage);
  }

  ClickedOutty(event: Event) {
    const evt = event.target as HTMLButtonElement;
    if (evt.classList.contains("view-order")) {
      this.typopup = false;
    }
  }

  private createFlightBooking() {
try{
    let flightRequest: ICreateFlightOrder = {
      selected_offers: [],
      payments: [],
      passengers: [],
    };
    flightRequest.payments.push({
      currency: this.loadedFlight.total_currency,
      amount: this.loadedFlight.actual_amount,
    });
    flightRequest.selected_offers.push(this.loadedFlight.id);
    const paxFormArray = this.checkoutFormGroup.get("paxFormData") as FormArray;
    for (let i = 0; i < paxFormArray.length; i++) {
      const paxFormGroup = paxFormArray.at(i) as FormGroup;

      let flightPax: CreateOrderPassenger = {
        type: this.loadedFlight.passengers[i]?.type,
        title: "mr",
        phone_number: this.toE164Format(this.mobileNoContactControl.value, this.countryName),
        id: this.loadedFlight.passengers[i]?.id,
        given_name:
          this.loadedFlight.passengers[i]?.given_name !== null
            ? this.loadedFlight.passengers[i]?.given_name
            : "null",
        gender: "m",
        family_name:
          this.loadedFlight.passengers[i]?.family_name !== null
            ? this.loadedFlight.passengers[i]?.family_name
            : "null",
        email: this.emailContactControl.value,
        born_on: paxFormGroup.get("dob").value,
      };
      if (this.loadedFlight.passenger_identity_documents_required === true) {
        let identityDocuments: IdentityDocument[] = [];
        identityDocuments.push({
          unique_identifier: paxFormGroup.get("passportNumber").value,
          type: "passport",
          issuing_country_code: paxFormGroup.get("nationality").value,
          expires_on: "4004-03-03",
        });
        flightPax.identity_documents = identityDocuments;
      }
      flightRequest.passengers.push(flightPax);
    }
    this.facadeCheckout.saveFlightOrder(flightRequest);
  } catch (error) {
    console.error('Error occurred:', error);
    this.isLoading = false;
  }
  }

  private createHotelBooking() {
try{
    let hotel: HotelBookingInterface = {
      holder: undefined,
      rooms: [],
    };
    hotel.holder = {
      name: this.firstNameContactControl.value,
      surname: this.lastNameContactControl.value,
    };
    let passagers: PaxesBookingInterface[] = [];
    const paxFormArray = this.checkoutFormGroup.get("paxFormData") as FormArray;
    for (let i = 0; i < paxFormArray.length; i++) {
      const paxFormGroup = paxFormArray.at(i) as FormGroup;
      let hotelPax: PaxesBookingInterface = {
        type: paxFormGroup.get("type").value === "adult" ? "AD" : "CH",
        roomId: "1",
        name: paxFormGroup.get("firstAndMiddleName").value,
        surname: paxFormGroup.get("lastName").value,
      };
      passagers.push(hotelPax);
    }
    hotel.rooms.push({
      rateKey: this.loadedHotel.rooms[0].rates[0].rateKey,
      paxes: passagers,
    });
    this.facadeCheckout.saveHotelOrder(hotel);
  }catch (error) {
    this.sharedService.Error('Hotel order failed!');
    this.isLoading = false;
  }
  }

  checkCityError(type: any) {
    return type.hasError("required") ? 'checkoutPage.formFields.city.requiredMessage' : "";
  }

  private createEventBooking() {
    if (this.loadedEvent) {
      let tickets: any[] = [];
      
      let attendeesDetails = this.paxFormGroups.map((paxFormGroup: FormGroup) => {
        const selectedCountry = this.countries.find(
          country => country.name === paxFormGroup.get('nationality')?.value
        );
        return {
          fullName: paxFormGroup.get('firstAndMiddleName')?.value + ' ' + paxFormGroup.get('lastName')?.value,
          birthDate: this.datePipe.transform(paxFormGroup.get('dob')?.value, 'dd/MM/yyyy'),
          cityOfBirth: paxFormGroup.get('city')?.value,
          passportNumber: paxFormGroup.get('passportNumber')?.value,
          nationalityCountryId: selectedCountry.id,
        };
      });
      for (const event of this.loadedEvent) {
        const staticTicketPrice = event.data[0].actualPrice;
        const deliveryPrice = event.data[0].delivery_cost;
        let eventDetail: IOrderTicketsDetails = {
          fullName: "trripi TEST",
          email: "trripi@gmail.com",
          country: event.eventData.location.country.name,
          phone: "3334445765",
          ticketId: event.data[0].ciid,
          //ticketId: event.data[0].ciid,
          quantity: event.data[0].seats,
          // deliveryId: 1006,
          deliveryId: event.data[0].provshipid,
          // deliveryPrice: deliveryPrice.toString(),
          deliveryPrice: event.data[0]?.delivery_cost,
          // ticketPrice: staticTicketPrice.toString(),
          ticketPrice: event.data[0]?.actualPrice, 
          orderTotalPrice: (deliveryPrice + (staticTicketPrice * event.data[0].seats)),
          // orderTotalPrice:
          //   event.data[0]?.delivery_cost +
          //   event.data[0]?.actualPrice * event.data[0].seats,
          currency: event.data[0].currency,
          shippingDetails: {
            hotelDelivery: {
              "phone": "3336587456",
              "guestFullName": "Test",
              "hotelName": "Test Hotel",
              "hotelAddress": "Test Address",
              "checkInDate": "2024-11-24"
            },
            homeDelivery: {
              "phone": "3336587456",
              "country": "Test Country",
              "address": "Test Address",
              "recipientName": "Test name",
              "zipCode": "12345"
            }
          },
          attendeesDetails: attendeesDetails,
          leadCustomerName: this.firstNameContactControl.value + ' ' + this.lastNameContactControl.value,
          leadCustomerEmail: this.emailContactControl.value,
          leadCustomerPhoneNumber: this.toE164Format(this.mobileNoContactControl.value, this.countryName),
          purchaseAlertConfirmation: true,
        };
        tickets.push(eventDetail);
      }
      if(this.eventBooking[0]?.orderConfirmation){
        this.flightHotelBooking();
        return
      }else{
        this.facadeCheckout.saveMultipleEventOrder({
          orderTickets: tickets,
        });      
      }
    }
  }

  private createOrderInfo() {
    this.orderId = this.generateOrderID();
    const finalCost: number = this.totalCost - this.discount > 0 ? this.totalCost - this.discount : 0;
    let order: IOrderInfo = {
      ticketsOrders: [],
      passengers: [],
      orderId: this.orderId,
      flightOrder: undefined,
      hotelOrder: undefined,
      originCountry: this.data.origin,
      destinationCountry: this.data.destination,
      payment: undefined,
      dates: undefined,
      totalPrice: this.totalCost,
      couponId:this.couponDetail && this.couponDetail.error===false?this.couponDetail.Id:'',
      orderStatus: OrderStatusEnum.PENDING,
      eventInfo: this.loadedEvent,
      flightInfo: this.loadedFlight,
      hotelInfo: this.loadedHotel,
      packageType: parseInt(this.data.packageType),
      originPrice: this.totalCost,
      ourPrice: finalCost,
      profit: 0,
      discountAmount: this.discount
    };
    const paxFormArray = this.checkoutFormGroup.get("paxFormData") as FormArray;
    for (let i = 0; i < paxFormArray.length; i++) {
      const paxFormGroup = paxFormArray.at(i) as FormGroup;

      order.passengers.push({
        type: paxFormGroup.get("type").value,
        firstAndMiddleName: paxFormGroup.get("firstAndMiddleName").value,
        lastName: paxFormGroup.get("lastName").value,
        dob: paxFormGroup.get("dob").value,
        nationality: paxFormGroup.get("nationality").value,
        passportNumber: paxFormGroup.get("passportNumber").value,
      });
    }
    if (this.eventBooking) {
      this.eventBooking.forEach((item, index) => {
        order.ticketsOrders.push({
          orderId: item.orderConfirmation.purchaseDetails.orderid.toString(),
          customerCost:
          item.orderConfirmation.purchaseDetails.totalPrice,
          provider: this.loadedEvent[index]?.eventData?.tickets[0]?.provider,
          ourCost: item.orderConfirmation.purchaseDetails.totalPriceEntered,
          name: this.loadedEvent[index]?.name,
        });
      });
    }
    if ((this.packageTypeId == 1 || this.packageTypeId == 2) && this.isObjectNotEmpty(this.flightBooking?.flightOrder)) {      
      order.flightOrder = {
        orderId: this.flightBooking?.flightOrder?.data?.id,
        customerCost: parseInt(
          this.flightBooking?.flightOrder?.data.total_amount
        ),
        provider: this.loadedFlight?.owner?.name,
        ourCost: parseInt(this.flightBooking?.flightOrder?.data.total_amount),
        name: this.loadedFlight?.owner?.name,
      }; 
    } else {
      order.flightOrder = {
        orderId: "",
        customerCost: 0,
        provider: "",
        ourCost: 0,
        name: "",
      };
    }
    if ((this.packageTypeId == 1 || this.packageTypeId == 3)  && this.isObjectNotEmpty(this.hotelBooking)) {
      order.hotelOrder = {
        orderId: this.hotelBooking?.reference,
        customerCost: this.hotelBooking?.totalNet,
        provider: this.loadedHotel?.name,
        ourCost: this.hotelBooking?.totalNet,
        name: this.loadedHotel?.name,
      };
    } else {
      order.hotelOrder = {
        orderId: "",
        customerCost: 0,
        provider: "",
        ourCost: 0,
        name: "",
      };
    }
    order.dates = {
      created: new Date(),
      from: new Date(this.data.inboundDate),
      to: new Date(this.data.outboundDate),
    };
    order.contactDetail = {
      firstName: this.firstNameContactControl.value,
      lastName: this.lastNameContactControl.value,
      mobileNo: this.mobileNoContactControl.value,
      email: this.emailContactControl.value,
    };
    this.facadeCheckout.saveOrder(order);
  }

  onSubmitForm() {
    this.isLoading = true;
    if (this.checkoutFormGroup.valid) {
      this.createEventBooking();
    } else {
      this.checkoutFormGroup.markAllAsTouched();
      this.isLoading = false;
    }
  }

  private generateOrderID() {
    const randomDigits = Math.floor(Math.random() * 100000000)
      .toString()
      .padStart(8, "0");
    return `${randomDigits}`;
  }

 

  onHandleCoupon(): void {
    this.CouponCallFlag=false;
    this.isApplying=true;
    this.couponInput=true;
    this.discount=0;
    this.facadeCheckout.getCouponDetail({
        code: this.couponControl.value,
      });
  }

  updateCouponCount():void{
    this.facadeCheckout.updateCouponCount({
      code: this.couponControl.value
    })
  }

  convertCurrency(amount, fromCurrency, toCurrency, exchangeRates) : string{
    if (fromCurrency === toCurrency) {
        return amount;
    }

    if (!exchangeRates.hasOwnProperty(fromCurrency) || !exchangeRates.hasOwnProperty(toCurrency)) {
      throw new Error("Exchange rate not found for the given currency pair");
  }

    // Convert fromCurrency to USD first
    const test = exchangeRates[fromCurrency];
    const amountInUSD = amount / exchangeRates[fromCurrency];
    // Convert USD to toCurrency
    const amountInTargetCurrency = amountInUSD * exchangeRates[toCurrency];

    return amountInTargetCurrency.toFixed(3);
}

enableApply(event:any) {
  let data=event.target.value;
  if(data){
    this.couponInput=false;
  }else{
    this.couponInput=true;
  }
  }
  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
    this.kill$.next(null);
    this.kill$.complete();
  }
}
